import {useEffect} from "react";


const BookingCom = ({lang}) => {
    // useEffect(() => {
    //     const script = document.createElement("script");
    //     script['type'] = 'text/babel';
    //     script['id'] = 'sp_widget';
    //     script['data-hash'] = '_d819a05f4e7a';
    //     script['data-container'] = 'b_container';
    //     script['data-size'] = '800x500';
    //     script['data-tpncy'] = 'false';
    //     script['src'] = 'booking_sp_widget.js?';
    //     document.body.appendChild(script);
    // }, [0])
    return (
        <div>
            {lang}
        </div>)
}

export default BookingCom;
